import React from 'react';
import { makeStyles } from '@material-ui/core';
import { MenuItemProps, MenuItem as MenuItemMUI } from '@ha/dsl';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.grey[600],
    paddingRight: '24px',
    paddingLeft: '24px',
    '&$selected': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.grey[700],
    },
  },
  selected: {},
}));

const MenuItem: React.FC<MenuItemProps> = ({ children, ...props }) => {
  const classes = useStyles();

  return (
    <MenuItemMUI
      {...props}
      button
      classes={{ root: classes.root, selected: classes.selected }}
    >
      {children}
    </MenuItemMUI>
  );
};

export default MenuItem;
